











































































import { staffList } from "@/api/globalSearch";
import {
  DistributeFollowStaffApi,
  DistributeFollowStaffData,
} from "@/api/lesson";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() ori!: any[];
  @Prop() hidePotential?: boolean;
  originArray: any[] = [];
  staffList: any[] = [];
  form: any = {
    follow_staff_id: "",
    join_potential: "",
  };
  dialogVisible: boolean = false;
  rules = {
    follow_staff_id: [
      { required: true, message: "请选择课程顾问", trigger: "change" },
    ],
  };
  openDialog() {
    if (this.ori.length === 0) {
      return false;
    }
    this.form = {
      follow_staff_id: "",
      join_potential: "",
    };
    if (this.hidePotential) {
      this.form.join_potential = "1";
    }
    this.dialogVisible = true;
    this.originArray = [...this.ori];
    staffList({ page: 1, page_size: 500, status: 1, job_ids: [3] }).then(
      (res: any) => {
        if (res.error_code === 0) {
          this.staffList = res.data.list;
        }
      }
    );
  }
  closeDialog() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    if (this.form.join_potential === "") {
      this.$message({
        type: "warning",
        message: "请先选择分配方式",
      });
      return false;
    }
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const arr: number[] = [];
          this.originArray.map((item: any) => {
            arr.push(item.student_id);
          });
          const params: DistributeFollowStaffData = {
            student_ids: arr,
            join_potential: this.form.join_potential === "2",
          };
          if (this.form.join_potential === "1") {
            params.follow_staff_id = Number(this.form.follow_staff_id);
          }
          DistributeFollowStaffApi(params).then(() => {
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.closeDialog();
            this.$emit("change");
          });
        }
      }
    );
  }
}
